import { useEffect, type Dispatch, type SetStateAction } from 'react';
import { TData } from 'entries/common/widgets/saved-project-configuration/context';

/**
 * Синхронизирует изменения presaleProps с хоста в локальный DataContext,
 * например loading из presaleProps
 */
export const useSyncPresaleProps = (
  presaleProps: TData['presaleProps'],
  setData: Dispatch<SetStateAction<TData>>
) => {
  useEffect(() => {
    if (!presaleProps) {
      return;
    }

    setData(prev => ({ ...prev, presaleProps }));
  }, [presaleProps, setData]);
};
